import React, { useEffect, useState } from "react";
import Select from "react-select";

import { Label, UncontrolledTooltip } from "reactstrap";

export default function SelectDisplay({ attributes, rowId, colId, setValue }) {
  const [selected, setSelected] = useState(() => attributes.value || "");
  const [selectedOption, setSelectedOption] = useState(() => {
    if (!attributes.value || !attributes.selectValues?.length) return null;
    if (attributes.isMulti) {
      const vals = Array.isArray(attributes.value)
        ? attributes.value
        : [attributes.value];
      return attributes.selectValues
        .filter((e) => vals.includes(e.name))
        .map((e) => ({ label: e.name, value: e.name }));
    }
    const match = attributes.selectValues.find((e) => e.name === attributes.value);
    return match ? { label: match.name, value: match.name } : null;
  });
  // FIX_SSR_SELECT — em SSR (renderToString do editor) `useEffect` não roda,
  // então `ssr` fica `true` e renderizamos um <details> estático com as
  // opções. No browser vivo (`/rsvp/formulario`, `/template/:id`) o effect
  // roda, vira `false` e o <Select> real do react-select assume.
  const [ssr, setSsr] = useState(true);
  useEffect(() => {
    setSsr(false);
  }, []);

  const handleChange = (e) => {
    if (!e) {
      setSelectedOption(null);
      setSelected("");
      return;
    }
    setSelectedOption(e);
    setSelected(attributes.isMulti ? e.map((x) => x.value) : e.value);
  };

  useEffect(() => {
    const html = attributes.label;
    const div = document.getElementsByClassName(
      `select-label-${rowId}-${colId}`,
    );

    for (const element of div) {
      element.innerHTML = html + (attributes.required ? '*' : '');
    }
  }, [attributes, rowId, colId]);

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value =
        selected?.length === 0 ? "" : selected;
      if (attributes.required && !selected) {
        newValue[rowId].cols[colId].attributes.errorMessage =
          `O campo ${attributes.inputName} é obrigatório`;
      } else {
        newValue[rowId].cols[colId].attributes.errorMessage = "";
      }

      return newValue;
    });
  }, [
    selected,
    setValue,
    rowId,
    colId,
    attributes.required,
    attributes.inputName,
  ]);

  return (
    <div className="custom-input-container">
      <div>
        <div className="displayed-config-container">
          <div className="displayed-label">
            {/* FIX_SSR_LABEL — children literal + inline. Concatena o "*"
                quando required pra manter o comportamento do useEffect
                original ao renderizar em SSR (editor via renderToString). */}
            <Label
              htmlFor="formFile"
              className={`form-label select-label-${rowId}-${colId}`}
              style={{ display: "inline", marginRight: 2 }}
            >
              {attributes.label}
              {attributes.required ? "*" : ""}
            </Label>
            {attributes.hasTip && (
              <div>
                <div className="show-tips" id={`select-tip-${rowId}-${colId}`}>
                  <span>?</span>
                </div>
                <UncontrolledTooltip
                  style={{ backgroundColor: "#6f42c1" }}
                  placement="right"
                  target={`select-tip-${rowId}-${colId}`}
                >
                  {attributes.tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      {ssr ? (
        // Mock estático do "campo select" — só a caixa fechada com placeholder
        // + seta. Visível no editor GrapesJS via renderToString (não expande,
        // apenas representa visualmente onde vai ficar o Select).
        <div className="ssr-select">
          <div className="ssr-select-summary">
            <span>{attributes.placeholder || "Selecione"}</span>
            <span className="ssr-select-arrow">
              <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0L10 11.295l3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
        </div>
      ) : (
        <Select
          placeholder={attributes.placeholder}
          isMulti={attributes.isMulti}
          isClearable
          value={selectedOption}
          onChange={handleChange}
          options={[
            {
              options: [
                ...attributes.selectValues.map((e) => {
                  return { label: e.name, value: e.name };
                }),
              ],
            },
          ]}
          id="formFile"
        />
      )}
    </div>
  );
}
